import { Link } from "react-router-dom";
import { UserAvatar } from "@/components/UserBits";

export const CongratsFans = ({ honor, max = 6 }) => {
  const fans = honor.fans || [];
  if (!fans.length) return null;
  const rest = (honor.congrats || 0) - Math.min(fans.length, max);
  return (
    <div className="flex items-center justify-center gap-2" data-testid={`honor-fans-${honor.user_id}`}>
      <div className="flex -space-x-2">
        {fans.slice(0, max).map((f) => (
          <Link key={f.user_id} to={`/u/${f.user_id}`} onClick={(e) => e.stopPropagation()} title={`${f.name} hat gratuliert`} data-testid={`honor-fan-${f.user_id}`}
            className="rounded-full ring-2 ring-white hover:-translate-y-0.5 transition-transform">
            <UserAvatar userId={f.user_id} name={f.name} picture={f.picture} size="w-7 h-7" text="text-[10px]" crown={false} noStory />
          </Link>
        ))}
      </div>
      <span className="text-xs font-semibold text-[#9a6a12]">{rest > 0 ? `+${rest} weitere haben gratuliert` : "haben gratuliert"}</span>
    </div>
  );
};
